import {  useEffect, useMemo, useRef, useState } from 'react';
import {  
  MaterialReactTable,
  // createRow,
  type MRT_ColumnDef, 
  useMaterialReactTable,
} from 'material-react-table';
//import { format, parseISO } from 'date-fns';
import {
  LocalizationProvider,
  DatePicker,
} from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import {  
  IconButton,
  ListItemIcon,
  MenuItem,
  Tooltip, 
} from '@mui/material';
import {
  QueryClient,
  QueryClientProvider, 
  useQuery,
} from '@tanstack/react-query';
import {  IPriorityProducts } from '../../interface/IOrders_Tasks';
import { AxiosInstance } from '../../api/apiInstance';
import { useNavigate } from 'react-router-dom';
import RefreshIcon from '@mui/icons-material/Refresh';
//import { AccountCircle } from '@mui/icons-material';
import ProductsItemHierarchyDialog from './ProductsItemHierarchyDialog';
import { muiTableBodyCellPropsHelper, muiTableHeadCellPropsHelper } from '../../helper/helper';
import { IproductHierarchy, IproductLocation } from '../../interface/IProducts';
import ExtensionIcon from '@mui/icons-material/Extension';
import PlaceIcon from '@mui/icons-material/Place';
import { useDispatch, useSelector } from 'react-redux';
import { incrementProducts } from '../../redux/ProductSlice';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import { IUser } from '../../interface/IUser';
function ProductItems  ()  {   
  const dispatch = useDispatch() 
  const [open, setOpen] = useState(false);
  const [partDialogDataLocation, setPartDialogDataLocation] = useState<IproductLocation[]>([]);
  const [partDialogDataHierarchy, setPartDialogDataHierarchy] = useState< IproductHierarchy[]>([]);
  const [dialogTitle, setDialogTitle] = useState('Part Hierarchy');
  const userinfo: IUser = useSelector((state: any) => state.user)
  const products: IPriorityProducts[] = useSelector((state: any) => state.products)
  const navigate = useNavigate();
  const [validationErrors, setValidationErrors] = useState<
    Record<string, string | undefined>
  >({});
  const hiddenColumns = {   
    id: false, 
    linePhotoBase64: false,
    TYPE: false,
  }   
const [globalFilter, setGlobalFilter] = useState<string | undefined>(    undefined  );
  const isFirstRender = useRef(true);
  useEffect(() => {
    const tmpGlobalFilter = sessionStorage.getItem('mrt_globalFilter_table_product');
    if (tmpGlobalFilter) {
      setGlobalFilter(JSON.parse(tmpGlobalFilter) || '');
    }
    console.log('useEffect', globalFilter , tmpGlobalFilter)
    isFirstRender.current = false;
  },[])

useEffect(() => {
    if (isFirstRender.current) return;
    if(globalFilter === undefined) return;
    console.log('useEffect- globalFilter', globalFilter )
    sessionStorage.setItem(
      'mrt_globalFilter_table_product',
      JSON.stringify(globalFilter ?? ''),
    );
  }, [globalFilter]);
  
  const resetState = () => {
   
    sessionStorage.removeItem('mrt_globalFilter_table_product');
    setGlobalFilter('');
    //refetch();
  };

  const handleClose = () => {
    setOpen(false);
  }
  
  // useEffect(()=>{
  //   async function GetData() {
  //     try {
  //       return await AxiosInstance({
  //         // url of the api endpoint (can be changed)
  //         url: "boxes",
  //         method: "GET",
  //       }).then((res) => {
  //         // handle success
         
  //         setBoxInfo( res.data)
  //       });
  //     } catch (e) {
  //       // handle error
  //       console.error(e);
       
  //     }
  //   }        
  // GetData();
  // console.log(orderData);
  // },[])



  const  GetPartHierarchyData = async (id: string) =>
  {
    setDialogTitle('Part Hierarchy');
    //setPartDialogData(['None']);
    try {
       await AxiosInstance({
        // url of the api endpoint (can be changed)
        url: "priorityProducts/findChildByParentPart/" + id,
        method: "GET",
      }).then((res) => {
        const data = res.data as IproductHierarchy[]; 
        //setPartDialogData(data.map((x)=>x?.PARTNAME + ' - ' + x?.PARTDES + ' - ' + x.stockDate?.substring(0,10) + ' - ' + x?.quantity));
        setPartDialogDataHierarchy(data);
                  
      });
    } catch (e) {
      
    }
  }    
  const  GetPartLocationData = async (id: string) =>
    {
      setDialogTitle('Part Location');
      //setPartDialogData(['None']);
      try {
         await AxiosInstance({
          // url of the api endpoint (can be changed)
          url: "priority-products-locations/findAllByProduct/" + id,
          method: "GET",
        }).then((res) => {
          const data = res.data as IproductLocation[];
          //setPartDialogData(data.map((x)=>x.zone.zoneName + ' -- ' +   x.location + ' -- ' +   x.stockDate?.substring(0,10) + ' -- ' +   x.quantity));
          setPartDialogDataLocation(data);
                    
        });
      } catch (e) {
        
      }
    }      
  const columns = useMemo<MRT_ColumnDef<IPriorityProducts>[]>(
    () => [
      {
        accessorKey: 'id',
        header: 'id',
        enableEditing: false,
        enableGlobalFilter: false,
       
      },
      {
        accessorKey: 'PARTNAME',
        header: 'Part name',
        enableEditing: false,
        FilterFn: 'contains',
       
      },
      {
        accessorKey: 'TYPE',
        header: 'TYPE',
        enableEditing: false,
        enableGlobalFilter: false,
       
      },    
       {
        accessorFn: (originalRow) => originalRow.zoneName ? originalRow.zoneName : '',
        //accessorKey: 'zoneName',
        header: 'zoneName',
        enableEditing: false,
        enableColumnFilter: false,
        //enableGlobalFilter: false,
        FilterFn: 'contains',
       
      },  
      {
        accessorKey: 'PARTDES',
        header: 'Description',
        enableEditing: false,
        FilterFn: 'contains',
       
      },
      {
        //accessorKey: 'location',
        accessorFn: (originalRow) => originalRow.location ? originalRow.location : '',
        header: 'location',
        enableEditing: false,
        enableColumnFilter: false,
        //enableGlobalFilter: false,
        FilterFn: 'contains',
       
      },       
      {
        accessorKey: 'stockDate',
        header: 'stock Date',
        enableEditing: false,
        enableColumnFilter: false,
        enableGlobalFilter: false,
               
     
        
      }, 
      {
        accessorKey: 'quantity',
        header: 'quantity',
        enableEditing: false,
        enableColumnFilter: false,
        enableGlobalFilter: false,
       
      },   
                     
      
      
      
    ],
    [validationErrors],
  );

 

  const {
    data: fetchedData = products || [] ,
    isError: isLoadingProductsError,
    isFetching: isFetchingProducts,
    isLoading: isLoadingProducts,
    refetch,
  } = useGetData();
  
  //READ hook (get Orders from api)
    function useGetData() {
      return useQuery<IPriorityProducts[]>({
        queryKey: ['priorityProducts'],
        queryFn: async () => {
          //send api request here
          let tmpUrl = 'priorityProducts';    
          //console.log('useGetData',products)
          // if (products !== null && products.length > 10) 
          // {
          //   console.log('useGetData count',products.length)
          //   return products as IPriorityProducts[];         
          // }
          return await AxiosInstance.get (
            tmpUrl,    
          
  
          ).then((res) => {
            const dt = res.data as IPriorityProducts[];              
            dispatch( incrementProducts( dt))           
            return dt.filter(g=>{if (g.TYPE === 'R')  return true; return false;});
          });
        },
        refetchOnWindowFocus: 'always',
      });
      
    }


  const table = useMaterialReactTable({
    columns,
    data: fetchedData, //.filter(r=>{if (r.TYPE === 'R') return true; return false;}),
   globalFilterFn: 'contains',
    
   
    renderRowActionMenuItems: ({ row, closeMenu }) => [
      <MenuItem
        key={0}
        onClick={async () => {
          // View profile logic...
          GetPartHierarchyData(row._valuesCache.PARTNAME);   
          setOpen(true);
          closeMenu();
        }}
        sx={{ m: 0 }}
      >
        <ListItemIcon>
          <ExtensionIcon style={{color:'#7CB9E8'}} />
        </ListItemIcon>
        View Hirarchy
      </MenuItem>,   
      <MenuItem
      key={0}
      onClick={async () => {
        // View profile logic...
        GetPartLocationData(row.id);   
        setOpen(true);
        closeMenu();
      }}
      sx={{ m: 0 }}
    >
      <ListItemIcon>
        <PlaceIcon style={{color:'lightgreen'}} />
      </ListItemIcon>
      View Locations
    </MenuItem>,                       
    ],
    enableDensityToggle:false,  
    enableHiding: false,
    onGlobalFilterChange: setGlobalFilter,
    enableColumnActions: false,
    enablePagination: true,
    initialState: { pagination: { pageSize: 15, pageIndex: 0 } ,
     columnVisibility: hiddenColumns ,
      density: 'compact',  
      showColumnFilters: true,              
    },
    muiPaginationProps: {
      color: 'primary',
      shape: 'rounded',
      showRowsPerPage: false,
      variant: 'outlined',
    },
    paginationDisplayMode: 'pages',
    enableRowActions: true,
   
    enableSorting:true,
    enableBottomToolbar:true,
    enableColumnFilters:false,
    
    enableColumnOrdering:false,
    enableColumnFilterModes:false,  
    enableFilterMatchHighlighting:true,
    enableGlobalFilter:true,
    
    enableFullScreenToggle: false,
    getRowId: (row) => row.id,      
    muiTableContainerProps: {
      sx: {
        minHeight: '300px',
      },
    },
 
    muiTableBodyProps: {
      sx: {
        //stripe the rows, make odd rows a darker color
        '& tr:nth-of-type(odd) > td': {
          backgroundColor: '#f5f5f5',
        },
      },
    },
     

    muiTableBodyRowProps: ({ row }) => ({
      onClick: (event) => {
        navigate('Products/' + row.id);
      },
      sx: {
        cursor: 'pointer', //you might want to change the cursor too when adding an onClick
      },
    }),
    muiTableHeadCellProps: {
      //no useTheme hook needed, just use the `sx` prop with the theme callback
      sx: (theme) => (muiTableHeadCellPropsHelper),
    }, 
    muiTableBodyCellProps: ({ column }) => ({
      //conditionally style pinned columns
      sx: {
        muiTableBodyCellPropsHelper
      },
    }),   
    renderTopToolbarCustomActions: ({ table }) => (
      <div>       
      <Tooltip arrow title={ globalFilter + "Clear filter"} >
          
          <IconButton 
            //disabled={userinfo.userRoleName === 'Administrator' ? false : true}
            size='large' onClick={resetState}>
            <SearchOffIcon style={{color: globalFilter === undefined || globalFilter.length === 0 ? 'grey' : 'red' }}/>
          </IconButton>
        </Tooltip>
          
       <Tooltip arrow title="Refresh Data">
          <IconButton size="large" onClick={() => refetch()}>
            <RefreshIcon />
          </IconButton>
        </Tooltip> 
     
      </div>
    ),
    state: {
      isLoading: isLoadingProducts, //cell skeletons and loading overlay
      showProgressBars: isFetchingProducts, //progress bars while refetching
      showAlertBanner: isLoadingProductsError,      
      globalFilter,      
      //ise: isLoadingProductsError,
    },
    
  });

  return <>  
 <ProductsItemHierarchyDialog
        selectedValueLocation={partDialogDataLocation}
        selectedValueHierarchy={partDialogDataHierarchy}
        open={open}
        onClose={handleClose}
        dialogTitle={dialogTitle}
      />
    <MaterialReactTable table={table}  /></>;
};


function validateItem(items: IPriorityProducts) {
console.log(items)
return {
  LOCATION: !validateRequired(items.location)
    ? 'Location is Required'
    : '',
};
}

const queryClient = new QueryClient();

const ExampleWithProviders = () => (
  //Put this with your other react-query providers near root of your app
  <QueryClientProvider client={queryClient}>
    <ProductItems />
  </QueryClientProvider>
);

export default ExampleWithProviders;

const validateRequired = (value: string) => !!value.length;







